module.exports = __webpack_public_path__ + "img/system-dungeon-img.a8122ded.jpg";